export { history } from './history';

export const RoutePath = {
  root: '/',
  loginRedirect: '/login',
  permissionDenied: '/permission-denied',

  // Product Information
  productInfo: '/product-info',

  // Configuration
  configurationRoot: '/configuration',
  // Configuration - General Settings
  configurationGeneralSettingsRoot: '/configuration/general-settings',
  configurationGeneralSettingsUntangler: '/configuration/general-settings/untangler',
  // Configuration - Employer Configuration
  configurationEmployerRoot: '/configuration/employer-configuration',
  configurationEmployerEntities: '/configuration/employer-configuration/entities',
  configurationEmployerEntityCreate: '/configuration/employer-configuration/entities/create',
  configurationEmployerEntityEdit: '/configuration/employer-configuration/entities/:entityId/edit',
  // Configuration - Employer Configuration - Policies
  configurationEmployerPolicies: '/configuration/employer-configuration/policies',
  configurationEmployerPolicyCreate: '/configuration/employer-configuration/policies/create',
  configurationEmployerPolicyEditRoot: '/configuration/employer-configuration/policies/:policyId/edit',
  configurationEmployerPolicyEditDetails: '/configuration/employer-configuration/policies/:policyId/edit/details',
  configurationEmployerPolicyEditParameters: '/configuration/employer-configuration/policies/:policyId/edit/parameters',
  configurationEmployerPolicyEditAudit: '/configuration/employer-configuration/policies/:policyId/edit/audit',
  configurationEmployerPolicyEditAuditDetails:
    '/configuration/employer-configuration/policies/:policyId/edit/audit/:auditId/details',
  configurationEmployerPolicyViewRoot: '/configuration/employer-configuration/policies/:policyId/view',
  configurationEmployerPolicyViewParameters: '/configuration/employer-configuration/policies/:policyId/view/parameters',
  configurationEmployerAudit: '/configuration/employer-configuration/audit',
  configurationEmployerAuditDetails: '/configuration/employer-configuration/audit/:auditId/details/:auditType',
  // Configuration - Scheme Configuration
  configurationSchemeRoot: '/configuration/scheme-configuration',
  configurationSchemeList: '/configuration/scheme-configuration/list',
  // Configuration - Scheme Configuration - Create
  configurationSchemeCreateRoot: '/configuration/scheme-configuration/create',
  // Configuration - Scheme Configuration - Edit
  configurationSchemeEditRoot: '/configuration/scheme-configuration/edit/:schemeId/type/:configurationType',
  configurationSchemeEditConfiguration:
    '/configuration/scheme-configuration/edit/:schemeId/type/:configurationType/configuration',
  configurationSchemeEditAudit: '/configuration/scheme-configuration/edit/:schemeId/type/:configurationType/audit',
  // Configuration - Scheme Configuration - View
  configurationSchemeViewRoot: '/configuration/scheme-configuration/view/:schemeId/type/:configurationType',
  configurationSchemeViewConfiguration:
    '/configuration/scheme-configuration/view/:schemeId/type/:configurationType/configuration',
  configurationSchemeViewAudit: '/configuration/scheme-configuration/view/:schemeId/type/:configurationType/audit',
  // Data Management
  dataManagementRoot: '/data-management',
  // Data Management - Processes
  dataManagementProcessRoot: '/data-management/process',
  dataManagementProcessCreateRoot: '/data-management/process/create',
  dataManagementProcessCreateUpload: '/data-management/process/create/upload',
  dataManagementProcessCreateMemberChecks: '/data-management/process/create/member',
  dataManagementProcessCreateBenefitAnalysis: '/data-management/process/create/benefit',
  dataManagementProcessCreateUnderwritingReview: '/data-management/process/create/underwriting',
  dataManagementProcessCreateReviewComplete: '/data-management/process/create/review',
  // Data Management - Processes - Summary
  dataManagementProcessSummary: '/data-management/process/summary',
  // Data Management - Processes - Summary - History
  dataManagementProcessSummaryHistoryRoot: '/data-management/process/summary/history',
  dataManagementProcessSummaryHistoryList: '/data-management/process/summary/history/list',
  dataManagementProcessSummaryHistoryDetailsRoot: '/data-management/process/summary/history/details',
  dataManagementProcessSummaryHistoryDetailsMemberChecks: '/data-management/process/summary/history/details/member',
  dataManagementProcessSummaryHistoryDetailsBenefitAnalysis: '/data-management/process/summary/history/details/benefit',
  dataManagementProcessSummaryHistoryDetailsAudit: '/data-management/process/summary/history/details/audit',
  dataManagementProcessSummaryHistoryDetailsUnderwriting:
    '/data-management/process/summary/history/details/underwriting',

  // Reporting
  reportingRoot: '/reporting',
  reportingInvoiceHistoryRoot: '/reporting/invoice-history',
  reportingInvoiceHistoryList: '/reporting/invoice-history/list',
  reportingInvoiceHistoryDetails: '/reporting/invoice-history/:reportHistoryId/details',
  reportingTemplatesRoot: '/reporting/templates',
  reportingTemplatesList: '/reporting/templates/list',
  // Create Template
  reportingTemplateCreate: '/reporting/templates/create',
  // Edit Template
  reportingTemplateEditRoot: '/reporting/templates/edit/:templateId',
  reportingTemplateEditDetails: '/reporting/templates/edit/:templateId/details',
  reportingTemplateEditContent: '/reporting/templates/edit/:templateId/content',
  reportingTemplateEditHistory: '/reporting/templates/edit/:templateId/history',
  // View Template
  reportingTemplateViewRoot: '/reporting/templates/view/:templateId',
  reportingTemplateViewDetails: '/reporting/templates/view/:templateId/details',
  reportingTemplateViewContent: '/reporting/templates/view/:templateId/content',
  reportingTemplateViewHistory: '/reporting/templates/view/:templateId/history',
};

export { GuardedRoute } from './GuardedRoute';
